"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _SafeGrid = _interopRequireDefault(require("01_core/components/materials/SafeGrid"));
var _labelConsts = require("../../constants/labelConsts");
var _stringConsts = require("../../constants/stringConsts");
var _CButton = _interopRequireDefault(require("../materials/CButton"));
var _CustomRouter = require("../system/CustomRouter");
var _Accordion = _interopRequireDefault(require("./Accordion"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 検索/集計条件の共通コンポーネント
 *
 * @prop {array} conditions - 検索/集計条件とするコンポーネントの配列
 * @prop {array} excConditions - オプション検索条件とするコンポーネントの配列
 * @prop {string} excConditionsTitle - オプション検索条件のタイトル
 * @prop {bool} totalize - 集計条件の場合true
 * @prop {func} [onSearchClick] - 検索/集計ボタン押下時のハンドラ（validateがtrueの場合は不要）
 * @prop {node} [cancelBtn] - 検索ボタンの左に配置するボタン
 * @prop {bool} validate - ValidatorFormが必要な部品を使っている場合true
 * @prop {bool} returnHome - ホームへ戻るボタンが必要な場合true
 */
function SearchCondition(props) {
  const {
    intl,
    className,
    conditions,
    excConditions,
    excConditionsTitle,
    returnHome,
    cancelBtn,
    onSearchClick,
    totalize,
    history,
    validate
  } = props;
  const titleLabel = totalize ? _labelConsts.LABEL.CORE_TOTALIZE_CONDITIONS : _labelConsts.LABEL.CORE_SEARCH_CONDITIONS;
  const btnLabel = totalize ? _labelConsts.LABEL.CORE_TOTALIZE : _labelConsts.LABEL.CORE_SEARCH;
  const searchButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    onClick: onSearchClick,
    submit: validate
  }, intl.formatMessage({
    id: btnLabel
  }));
  const actions = [];
  if (cancelBtn) {
    actions.push(cancelBtn);
  } else if (returnHome) {
    actions.push(/*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      negative: true,
      onClick: () => {
        history.push(_stringConsts.STRING_CONSTS.ROOT_PATH);
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TO_RETURN_HOME
    })));
  }
  actions.push(searchButton);
  const optionsTitle = excConditionsTitle ? excConditionsTitle : intl.formatMessage({
    id: _labelConsts.LABEL.CORE_OPTIONAL_SEARCH_CONDITIONS
  });
  return /*#__PURE__*/_react.default.createElement(_Accordion.default, {
    title: intl.formatMessage({
      id: titleLabel
    }),
    className: className,
    actions: actions
  }, Array.isArray(conditions) ? /*#__PURE__*/_react.default.createElement(_SafeGrid.default, {
    container: true,
    spacing: 2
  }, conditions.map((item, index) => /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      sm: 12,
      md: 6
    },
    style: {
      textAlign: 'left'
    },
    key: 'condition_' + index
  }, item || null)), Array.isArray(excConditions) && excConditions.length > 0 ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      sm: 12,
      md: 12
    },
    style: {
      textAlign: 'left'
    },
    key: 'excondition'
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
    defaultExpanded: false,
    title: optionsTitle
  }, /*#__PURE__*/_react.default.createElement(_SafeGrid.default, {
    container: true,
    spacing: 2
  }, excConditions.map((item, index) => /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      sm: 12,
      md: 6
    },
    style: {
      textAlign: 'left'
    },
    key: 'excondition_' + index
  }, item || null))))) : null) : null);
}
SearchCondition.propTypes = {
  conditions: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
  excConditions: _propTypes.default.arrayOf(_propTypes.default.node),
  excConditionsTitle: _propTypes.default.string,
  totalize: _propTypes.default.bool,
  onSearchClick: _propTypes.default.func,
  validate: _propTypes.default.bool,
  returnHome: _propTypes.default.bool,
  cancelBtn: _propTypes.default.node,
  className: _propTypes.default.string
};
var _default = exports.default = (0, _CustomRouter.withRouter)((0, _reactIntl.injectIntl)(SearchCondition));